<router-outlet name="publicHeaderMenu"></router-outlet>

<main id="main">
  <router-outlet></router-outlet>
</main>
